module.exports = __webpack_public_path__ + "static/img/fucking-great.108599c9.png";